export type RadioItem = Required<{ [key in string]: any }>;

export type RadioListProps<T extends RadioItem> = Readonly<{
  list: T[];
  labelKey: keyof T;
  value?: T;
  onChange: (value: T) => void | Promise<void>;
  direction?: 'row' | 'column';
  className?: string;
}>;

const style = (direction = 'row') => ({
  display: 'flex',
  ...(direction === 'column' ? {
    flexDirection: 'column' as const,
    alignItems: 'flex-start',
  } : {
    alignItems: 'center',
  }),
  gap: '2rem',
  '& > label': {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  '& input': {
    margin: '0',
    padding: '0',
  },
});

const RadioList = <T extends RadioItem>(props: RadioListProps<T>) => {
  const onChange = async (listIndex: number) => {
    await props.onChange(props.list[listIndex]);
  };

  const itemList = Array(props.list.length).fill(null).map((_, index) => ({
    value: props.list[index],
    label: props.list[index][props.labelKey],
  }));

  return <div css={style(props.direction)} className={props.className}>
    {itemList.map(({ value, label }, index) => (
      <label key={index}>
        <input type='radio' value={index} onChange={() => onChange(index)} checked={value === props.value} />
        {label}
      </label>
    ))}
  </div>;
};

export default RadioList;
